import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import { ServicesIndex, ServicePage } from "@/pages/Services";
import ServiceAreaPage from "@/pages/ServiceArea";
import { LocationsIndex, ProvincePage, CityPage } from "@/pages/Locations";
import { SectorsIndex, SectorPage } from "@/pages/Sectors";
import { InsightsIndex, ArticlePage } from "@/pages/Insights";
import SitemapPage from "@/pages/SitemapPage";
import Admin from "@/pages/Admin";
import Contact from "@/pages/Contact";
import { FrHub, FrProvince, FrCity, FrService, FrServiceProv, FrServiceCity } from "@/pages/Fr";
import NotFound from "@/pages/NotFound";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function Tracker() {
  const loc = useLocation();
  useEffect(() => {
    axios.post(`${API}/analytics/pageview`, { path: loc.pathname, referrer: document.referrer || "" }).catch(() => {});
  }, [loc.pathname]);
  return null;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about/" element={<About />} />
        <Route path="/services/" element={<ServicesIndex />} />
        <Route path="/services/:serviceSlug/" element={<ServicePage />} />
        <Route path="/services/:serviceSlug/:areaSlug/" element={<ServiceAreaPage />} />
        <Route path="/locations/" element={<LocationsIndex />} />
        <Route path="/locations/:provSlug/" element={<ProvincePage />} />
        <Route path="/locations/:provSlug/:citySlug/" element={<CityPage />} />
        <Route path="/sectors/" element={<SectorsIndex />} />
        <Route path="/sectors/:sectorSlug/" element={<SectorPage />} />
        <Route path="/insights/" element={<InsightsIndex />} />
        <Route path="/insights/:articleSlug/" element={<ArticlePage />} />
        <Route path="/sitemap/" element={<SitemapPage />} />
        <Route path="/contact/" element={<Contact />} />
        <Route path="/admin/" element={<Admin />} />
        <Route path="/fr/" element={<FrHub />} />
        <Route path="/fr/quebec/" element={<FrProvince />} />
        <Route path="/fr/quebec/:citySlug/" element={<FrCity />} />
        <Route path="/fr/services/:serviceSlug/" element={<FrService />} />
        <Route path="/fr/services/:serviceSlug/quebec/" element={<FrServiceProv />} />
        <Route path="/fr/services/:serviceSlug/:citySlug/" element={<FrServiceCity />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Tracker />
      <AppRoutes />
    </BrowserRouter>
  );
}
